// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.10.2 (commit 58d2a40718c59535fd5c267e836d473298eb84d5).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AdminCommandReducer from "./admin_command_reducer";
import AttackReducer from "./attack_reducer";
import BagDepositReducer from "./bag_deposit_reducer";
import BagTakeReducer from "./bag_take_reducer";
import BagTakeAllReducer from "./bag_take_all_reducer";
import BlockReducer from "./block_reducer";
import ChatSendReducer from "./chat_send_reducer";
import ConfigureAuthReducer from "./configure_auth_reducer";
import ConfigureWorldReducer from "./configure_world_reducer";
import CraftReducer from "./craft_reducer";
import CreateCharacterReducer from "./create_character_reducer";
import DeopReducer from "./deop_reducer";
import DestroyItemReducer from "./destroy_item_reducer";
import DropItemReducer from "./drop_item_reducer";
import FriendActionReducer from "./friend_action_reducer";
import GatherEntityReducer from "./gather_entity_reducer";
import HelloReducer from "./hello_reducer";
import IgnoreActionReducer from "./ignore_action_reducer";
import InputReducer from "./input_reducer";
import InteractCancelReducer from "./interact_cancel_reducer";
import InteractStartReducer from "./interact_start_reducer";
import InventoryMoveReducer from "./inventory_move_reducer";
import InventoryQuickMoveReducer from "./inventory_quick_move_reducer";
import KickReducer from "./kick_reducer";
import LeaveWorldReducer from "./leave_world_reducer";
import MapRequestReducer from "./map_request_reducer";
import OpReducer from "./op_reducer";
import PartyActionReducer from "./party_action_reducer";
import QuestActionReducer from "./quest_action_reducer";
import RekindleReducer from "./rekindle_reducer";
import ReleaseCorpseReducer from "./release_corpse_reducer";
import SayReducer from "./say_reducer";
import SelectCharacterReducer from "./select_character_reducer";
import TalentActionReducer from "./talent_action_reducer";
import TalkNpcReducer from "./talk_npc_reducer";
import TradeActionReducer from "./trade_action_reducer";
import UseItemReducer from "./use_item_reducer";
import UsePortalReducer from "./use_portal_reducer";
import VendorActionReducer from "./vendor_action_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import BodyRow from "./body_table";
import BuffRow from "./buff_table";
import ClockRow from "./clock_table";
import CombatEventRow from "./combat_event_table";
import CorpseRow from "./corpse_table";
import EntityRow from "./entity_table";
import HealZoneRow from "./heal_zone_table";
import MyOutboxRow from "./my_outbox_table";
import PlacedEntityRow from "./placed_entity_table";
import TileEntityRow from "./tile_entity_table";
import VisibleBagRow from "./visible_bag_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  body: __table({
    name: 'body',
    indexes: [
      { accessor: 'entityId', name: 'body_entity_id_idx_btree', algorithm: 'btree', columns: [
        'entityId',
      ] },
      { accessor: 'instance', name: 'body_instance_idx_btree', algorithm: 'btree', columns: [
        'instance',
      ] },
    ],
    constraints: [
      { name: 'body_entity_id_key', constraint: 'unique', columns: ['entityId'] },
    ],
  }, BodyRow),
  buff: __table({
    name: 'buff',
    indexes: [
      { accessor: 'entityId', name: 'buff_entity_id_idx_btree', algorithm: 'btree', columns: [
        'entityId',
      ] },
      { accessor: 'id', name: 'buff_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'instance', name: 'buff_instance_idx_btree', algorithm: 'btree', columns: [
        'instance',
      ] },
    ],
    constraints: [
      { name: 'buff_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, BuffRow),
  clock: __table({
    name: 'clock',
    indexes: [
      { accessor: 'id', name: 'clock_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'clock_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ClockRow),
  combatEvent: __table({
    name: 'combat_event',
    indexes: [
      { accessor: 'id', name: 'combat_event_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'instance', name: 'combat_event_instance_idx_btree', algorithm: 'btree', columns: [
        'instance',
      ] },
    ],
    constraints: [
      { name: 'combat_event_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, CombatEventRow),
  corpse: __table({
    name: 'corpse',
    indexes: [
      { accessor: 'entityId', name: 'corpse_entity_id_idx_btree', algorithm: 'btree', columns: [
        'entityId',
      ] },
      { accessor: 'instance', name: 'corpse_instance_idx_btree', algorithm: 'btree', columns: [
        'instance',
      ] },
    ],
    constraints: [
      { name: 'corpse_entity_id_key', constraint: 'unique', columns: ['entityId'] },
    ],
  }, CorpseRow),
  entity: __table({
    name: 'entity',
    indexes: [
      { accessor: 'entityId', name: 'entity_entity_id_idx_btree', algorithm: 'btree', columns: [
        'entityId',
      ] },
      { accessor: 'instance', name: 'entity_instance_idx_btree', algorithm: 'btree', columns: [
        'instance',
      ] },
    ],
    constraints: [
      { name: 'entity_entity_id_key', constraint: 'unique', columns: ['entityId'] },
    ],
  }, EntityRow),
  healZone: __table({
    name: 'heal_zone',
    indexes: [
      { accessor: 'id', name: 'heal_zone_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'instance', name: 'heal_zone_instance_idx_btree', algorithm: 'btree', columns: [
        'instance',
      ] },
    ],
    constraints: [
      { name: 'heal_zone_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, HealZoneRow),
  placedEntity: __table({
    name: 'placed_entity',
    indexes: [
      { accessor: 'instance', name: 'placed_entity_instance_idx_btree', algorithm: 'btree', columns: [
        'instance',
      ] },
      { accessor: 'key', name: 'placed_entity_key_idx_btree', algorithm: 'btree', columns: [
        'key',
      ] },
    ],
    constraints: [
      { name: 'placed_entity_key_key', constraint: 'unique', columns: ['key'] },
    ],
  }, PlacedEntityRow),
  tileEntity: __table({
    name: 'tile_entity',
    indexes: [
      { accessor: 'id', name: 'tile_entity_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'instance', name: 'tile_entity_instance_idx_btree', algorithm: 'btree', columns: [
        'instance',
      ] },
    ],
    constraints: [
      { name: 'tile_entity_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, TileEntityRow),
  myOutbox: __table({
    name: 'my_outbox',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOutboxRow),
  visibleBag: __table({
    name: 'visible_bag',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleBagRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("admin_command", AdminCommandReducer),
  __reducerSchema("attack", AttackReducer),
  __reducerSchema("bag_deposit", BagDepositReducer),
  __reducerSchema("bag_take", BagTakeReducer),
  __reducerSchema("bag_take_all", BagTakeAllReducer),
  __reducerSchema("block", BlockReducer),
  __reducerSchema("chat_send", ChatSendReducer),
  __reducerSchema("configure_auth", ConfigureAuthReducer),
  __reducerSchema("configure_world", ConfigureWorldReducer),
  __reducerSchema("craft", CraftReducer),
  __reducerSchema("create_character", CreateCharacterReducer),
  __reducerSchema("deop", DeopReducer),
  __reducerSchema("destroy_item", DestroyItemReducer),
  __reducerSchema("drop_item", DropItemReducer),
  __reducerSchema("friend_action", FriendActionReducer),
  __reducerSchema("gather_entity", GatherEntityReducer),
  __reducerSchema("hello", HelloReducer),
  __reducerSchema("ignore_action", IgnoreActionReducer),
  __reducerSchema("input", InputReducer),
  __reducerSchema("interact_cancel", InteractCancelReducer),
  __reducerSchema("interact_start", InteractStartReducer),
  __reducerSchema("inventory_move", InventoryMoveReducer),
  __reducerSchema("inventory_quick_move", InventoryQuickMoveReducer),
  __reducerSchema("kick", KickReducer),
  __reducerSchema("leave_world", LeaveWorldReducer),
  __reducerSchema("map_request", MapRequestReducer),
  __reducerSchema("op", OpReducer),
  __reducerSchema("party_action", PartyActionReducer),
  __reducerSchema("quest_action", QuestActionReducer),
  __reducerSchema("rekindle", RekindleReducer),
  __reducerSchema("release_corpse", ReleaseCorpseReducer),
  __reducerSchema("say", SayReducer),
  __reducerSchema("select_character", SelectCharacterReducer),
  __reducerSchema("talent_action", TalentActionReducer),
  __reducerSchema("talk_npc", TalkNpcReducer),
  __reducerSchema("trade_action", TradeActionReducer),
  __reducerSchema("use_item", UseItemReducer),
  __reducerSchema("use_portal", UsePortalReducer),
  __reducerSchema("vendor_action", VendorActionReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.10.2" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

